






















































































import { Component, Prop, Vue } from "vue-property-decorator";
import { IFilmCategory as ICat } from "@/@types/cinema/film-category";
import { multimedia } from "@/config/host.config";

import Inputseartch from "@/components/app/search/input-search.vue";
import draggable from "vuedraggable";
import ChangeCategoryForm from "@/components/forms/cinema/change-category-form.vue";
import StandartCategoryName from "@/components/app/card/standart-category-name.vue";
import StandartModal from "@/components/app/standart-modal.vue";

@Component({
  components: {
    StandartModal,
    draggable,
    "input-search": Inputseartch,
    ChangeCategoryForm,
    StandartCategoryName,
  },
})
export default class AddCinemaCategoryForm extends Vue {
  @Prop({ type: Array, default: () => [] }) categoryList!: Array<ICat>;
  @Prop({ type: Array, default: () => [] }) categorys!: Array<string>;

  search = "";
  enabled = true;
  dragging = false;

  get cats(): Array<ICat> {
    return this.categoryList.filter((item) => {
      if (item && item.name) {
        return (
          this.$getLocale(item.name)
            .toLowerCase()
            .indexOf(this.search.toLowerCase()) > -1
        );
      }
    });
  }

  async updateCategory(category: ICat, id: string | null): Promise<void> {
    let url = multimedia.categorys;
    if (!id) this.$bvModal.hide("addCategory");
    try {
      const categorys = await this.$axios.post(url, category);
      if (categorys.status === 200) {
        this.$notify({
          group: "global",
          text: String(this.$i18n.t("error.200")),
        });
        this.$emit("updateCategory", categorys.data);
        this.$bvModal.hide("addCategory");
        return;
      }
      this.$emit("updateCategory", undefined);
      this.$bvModal.hide("addCategory");
    } catch (error) {
      this.$notify({
        group: "global",
        text: String(this.$i18n.t("alerts.emptyUpdate")),
        type: "warn",
      });
    }
  }
}
